import React from "react";
import BlogList from "./BlogList";

function ProBlogList() {
  return <BlogList api={`${import.meta.env.VITE_BACKEND_URL}/edu/pro-blogs`} />;
}

export default ProBlogList;
